import { requestType, SUPPLIER_ENDPOINTS } from "../../constants/Variables";
import Api from "../index";

const getAllSupplierOrders = (id, query) => {
  const url = SUPPLIER_ENDPOINTS.ORDER.GET_ALL_ORDERS.replace(
    ":supplierId",
    id,
  );

  const queryParams = new URLSearchParams();
  if (query.orderId) queryParams.append("orderId", query.orderId);
  if (query.page) queryParams.append("page", query.page);
  if (query.limit) queryParams.append("limit", query.limit);

  const finalUrl = queryParams.toString()
    ? `${url}?${queryParams.toString()}`
    : url;
  return Api(finalUrl, null, requestType.GET);
};

const getSingleSupplierOrderById = (id, orderId) => {
  const url = SUPPLIER_ENDPOINTS.ORDER.SINGLE_ORDER_BY_ID.replace(
    ":supplierId",
    id,
  ).replace(":id", orderId);
  return Api(url, null, requestType.GET);
};

const updateSupplierOrderItemStatus = (id, itemId, status) => {
  return Api(
    SUPPLIER_ENDPOINTS.ORDER.UPDATE_ORDER_ITEM_STATUS.replace(
      ":id",
      id,
    ).replace(":itemId", itemId),
    status,
    requestType.PATCH,
  );
};

const updateSupplierOrderStatusInBulk = (id, payload) => {
  return Api(
    SUPPLIER_ENDPOINTS.ORDER.UPDATE_ORDER_STATUS_IN_BULK.replace(":id", id),
    payload,
    requestType.PATCH,
  );
};

const getDonationByOrderId = (orderId) => {
  return Api(
    SUPPLIER_ENDPOINTS.DONATION.GET_SINGLE_BY_ORDER_ID.replace(
      ":orderId",
      orderId,
    ),
    null,
    requestType.GET,
  );
};

export {
  getAllSupplierOrders,
  getSingleSupplierOrderById,
  updateSupplierOrderItemStatus,
  updateSupplierOrderStatusInBulk,
  getDonationByOrderId,
};
